// app/javascript/controllers/cart_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count"]
  static classes = ["active"]
  static values = {
    productId: Number,
    inCart: Boolean
  }

  async toggle() {
    if (this.inCartValue) {
      await this.removeFromCart()
    } else {
      await this.addToCart()
    }
  }

  async addToCart() {
    try {
      const response = await fetch("/cart_items", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]").content
        },
        body: JSON.stringify({ product_id: this.productIdValue })
      })

      const data = await response.json()

      if (response.ok) {
        this.element.classList.add(...this.activeClasses)
        this.inCartValue = true

        // Dispatch custom event with cart data
        const event = new CustomEvent("cart:updated", {
          detail: { count: data.cart_count },
          bubbles: true
        })
        this.element.dispatchEvent(event)
      } else {
        // Handle case where product is already in cart
        console.warn(data.message)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  async removeFromCart() {
    try {
      const response = await fetch(`/cart_items_by_product/${this.productIdValue}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]").content
        }
      })

      const data = await response.json()

      if (response.ok) {
        this.element.classList.remove(...this.activeClasses)
        this.inCartValue = false

        // Dispatch custom event with cart data
        const event = new CustomEvent("cart:updated", {
          detail: { count: data.cart_count },
          bubbles: true
        })
        this.element.dispatchEvent(event)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
}
